import styled from '../utils/styled-components-wrapper.js'
import { withStyledSystem } from '../styled-system/index.js'

export const Box = withStyledSystem(styled.div``)
